import React, { useContext, useState } from 'react'
import axios from 'axios'
import { get, isEmpty, map, find, keys } from 'lodash'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { Select, MenuItem, Checkbox, ListItemText, Input, FormControl, FormHelperText, RadioGroup, Radio, FormControlLabel } from '@material-ui/core'
import { AnnotationContext, BookInfo, Errors, UserInfo, SelectionContext } from '../../contexts/menuContext'

// eslint-disable-next-line react/prop-types
const EditAnnotation = ({ annotationObj, setReload, page, content = '', defaults = null, setStatus = false }) => {
  const [user, setUser] = useContext(UserInfo)
  const groups = get(user, 'groups')
  const [value, setValue] = useState(content)
  const [, , , , , ,,, csrfToken] = useContext(BookInfo)
  const [visibility, setVisibility] = useState(get(defaults, 'visibility', 'private'))
  const [groupSelection, setGroupSelection] = useState(keys(get(defaults, 'groups', {})))
  const [, setAnnotationObj] = useContext(AnnotationContext)
  const [, setError] = useContext(Errors)
  const [annotationStatus, setAnnotationStatus] = useState(false);
  const [, setSelection, ] = useContext(SelectionContext)
  const changeRadio = (e) => {
    setVisibility(e)
  }
  const cancelHandler = () => {
    setAnnotationObj({})
    if (setStatus) {
      setStatus(false)
    }
  }
  return (
    <>
      {get(user, 'id', 0) > 0 &&
      <>
        <CKEditor
          data={value}
          editor={ClassicEditor}
          onChange={(event, editor) => {
            const data = editor.getData()
            setValue(data)
          }}
          onError={() => {}}
          config={{
            toolbar: ['undo', 'redo', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'indent', 'outdent'],
          }}
        />
        <div className="annotation-form-selections">

          {!isEmpty(groups) && <>
            {visibility === 'shared' &&
              <FormControl>
                <Select
                  labelId="demo-mutiple-checkbox-label"
                  id="demo-mutiple-checkbox"
                  multiple
                  value={groupSelection}
                  onChange={(e) => {
                    setGroupSelection(e.target.value)
                  }}
                  input={<Input />}
                  renderValue={(selected) => {
                    return selected.map((i, num) => {
                      const str = find(groups, (g) => {
                        return g.id === `${i}`
                      })
                      return num === selected.length - 1 ? `${str.title}` : `${str.title}, `
                    })
                  }}
                >
                  {map(groups, (groupValue, id) => (
                    <MenuItem key={id} value={id}>
                      <Checkbox checked={groupSelection.includes(id)} />
                      <ListItemText primary={groupValue.title} />
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>Choose groups to share with</FormHelperText>
              </FormControl>
            }
          </>}

        </div>
        <div className="annotation-form-submit">
          <div className="annotation-save">
            <button
              type="button"
              className="btn btn-secondary btn-save-annotation"
              disabled={annotationStatus}
              onClick={() => {
                setAnnotationStatus(true)
                setAnnotationObj({ ...annotationObj, value })
                const obj = { ...annotationObj, value }
                const postObj = {
                  text: { text: obj.text, selection: obj.selection },
                  content: obj.value,
                  visibility,
                  reference_id: obj.page
                }
                setSelection( {selection: {start: postObj.text.selection.start, end: postObj.text.selection.end}, page: obj.page, text: postObj.text.text })
                if (visibility === 'shared') {
                  postObj.groups = groupSelection
                }
                if (defaults) {
                  postObj.reference_id = page
                  axios.patch(`/bookreader/toolbox/annotation/${defaults.id}`, postObj, {
                    headers: {
                      'X-CSRF-Token': csrfToken
                    }
                  }).then((response) => {
                    const newUserObj = {...user};
                    newUserObj.annotations.push(obj.page);
                    setUser(newUserObj)
                    setAnnotationStatus(false)
                    setAnnotationObj({})
                    setStatus(false)
                    setReload(Date.now())
                    const err = get(response, 'data.data[0].errors')
                    if (err) {
                      setError(err[0])
                    }
                  })
                } else {
                  axios.post('/bookreader/toolbox/annotation', postObj, {
                    headers: {
                      'X-CSRF-Token': csrfToken
                    }
                  }).then((response) => {
                    const newUserObj = {...user};
                    newUserObj.annotations.push(obj.page);
                    setUser(newUserObj)
                    setAnnotationStatus(false)
                    setAnnotationObj({})
                    setReload(Date.now())
                    const err = get(response, 'data.data[0].errors')
                    if (err) {
                      setError(err[0])
                    }
                  })
                }
              }}
            >
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              Add Annotation
            </button>

          </div>

          <button type="button" className="btn btn-light" onClick={() => { cancelHandler() }}>Cancel</button>
        </div>
      </>}
    </>
  )
}

export default EditAnnotation
